import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';

import NavRoutes from './Helpers/NavRoutes';

import { SnackbarProvider } from 'notistack';

import AuthProvider from './Auth/AuthProvider';

export const getRowData = (data) => {};

export const App = () => {
  return (
    <Router basename='/multilayer'>
      <SnackbarProvider maxSnack={3}>
        <AuthProvider>
          <NavRoutes />
        </AuthProvider>
      </SnackbarProvider>
    </Router>
  );
};
